import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-supporters',
  templateUrl: './supporters.component.html',
  styleUrls: ['./supporters.component.scss']
})
export class SupportersComponent implements OnInit {

  @Input() subsCount;
  supporterImg;
  @Input() label = 'donors are giving monthly';

  constructor(
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.supporterImg = `${environment.APP.IMAGE_DOMAIN}/images/random_supporters/${Math.floor(Math.random() * 10) + 1}.png`;
    this.variablesService.getSubsCount();
    this.variablesService.subsCount.subscribe((res: any) => {
      if (!this.subsCount) {
        this.subsCount = res;
      }
    });
  }

}
